import React from 'react';
import './style.css';

const Loading = ({
  principal,
  secundario,
  noFullScreen = false,
  className = '',
}) => {
  if (noFullScreen) {
    return (
      <div className={`text-center ${className}`}>
        <h3 style={{ fontSize: '40px' }}>{principal || 'Procesando'}</h3>
        <div className="loader">Loading...</div>
        <h5>{secundario || ''}</h5>
      </div>
    );
  } else {
    return (
      <div
        className={`container ${className}`}
        style={{ height: '100vH' }}
      >
        <div className="row justify-content-center h-100">
          <div className="col-12 text-center align-self-center">
            <h3 style={{ fontSize: '40px' }}>{principal || 'Procesando'}</h3>

            <div className="loader">Loading...</div>

            <h5>{secundario || ''}</h5>
          </div>
        </div>
      </div>
    );
  }
};

export default Loading;
